import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FullNameComponent } from 'src/app/shared/full-name/full-name.component';
import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { AppClient } from 'src/app/core/app.client';
import { Student } from './shared/student.model';
import { School } from 'src/app/models/school.model';
import { SchoolSystem } from '../../models/state.model';
import { DateOfBirthComponent } from '../../shared/date-of-birth/date-of-birth.component';

@Component({
  selector: 'student',
  templateUrl: './student.component.html',
})
export class StudentComponent implements OnInit {
  @ViewChild(FullNameComponent) fullNameComponent: FullNameComponent;
  @ViewChild(DateOfBirthComponent) dateOfBirthComponent: FullNameComponent;

  isStaff = this.store.state.isStaff;
  title = this.isStaff ? 'student.titleStaff' : 'student.titleParent' ;
  progressBar = this.progress.student;
  genders: Array<string> = ['Male', 'Female', 'Neutral'];
  schools: Array<School> = [];
  student: Student = this.store.state.consent.student;
  schoolSystem: SchoolSystem = this.store.state.schoolSystem;

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService,
    private client: AppClient) { }

  ngOnInit() {
    this.client.getSchools(this.schoolSystem)
      .subscribe(schools => {
        this.schools = schools;
      });
  }

  disabled(): boolean {
    return this.fullNameComponent.form.valid &&
      this.dateOfBirthComponent.form.valid
  }

  back() {
    this.router.navigate([this.navigation.student.back]);
  }

  next() {
    if (this.isStaff) {
        if (this.schoolSystem == SchoolSystem.Jcps) {
          this.student.schoolId = this.schools.filter(e => e.name === 'JCPS Faculty/Staff')[0].id;
        }
        else if (this.schoolSystem == SchoolSystem.Madison) {
          this.student.schoolId = this.schools.filter(e => e.name === 'Madison Faculty/Staff')[0].id;
        }
      } else {
        this.store.state.schoolName = this.schools.filter(e => e.id === this.student.schoolId)[0].name;

        // For students there is no tobacco and alcohol page so making values false here
        this.student.tobacco = false;
        this.student.alcohol = false;
      }

    this.store.state.consent.student = this.student;
    this.router.navigate([this.navigation.student.next]);
  }

}
